import produce from 'immer';
import { requestGet, requestPut } from '../utils/httpService';
import {
  getRequestWithAuth,
  putRequestWithAuth,
} from 'actions/client-http.actions';
import { authorizedServerFetch } from 'actions/server.actions';
import useStore from './store';

export const dispatchFetchTasks = async () => {
  const isNPAdmin = useStore.getState().user.isNonProfitAdmin;
  if (isNPAdmin) {
    const tasksRes = await authorizedServerFetch(`npo-admin/tasks/pending`);
    useStore.setState(
      produce((draft) => {
        draft.notification.tasks = tasksRes?.data?.data || [];
        draft.notification.pendingTaskCount = draft.notification.tasks.length;
      }),
    );
    return tasksRes.data.data || [];
  }
};

export const dispatchGetNotifications = async () => {
  const { data, ok } = await authorizedServerFetch(`notification`);
  if (ok) {
    useStore.setState(
      produce((draft) => {
        draft.notification.isInitialized = true;
        draft.notification.allRows = data?.data || [];
      }),
    );
  }
  dispatchFetchTasks();
};

export const dispatchGetUnreadCount = async () => {
  const { data, ok } = await authorizedServerFetch(`notification/unread`);
  if (ok) {
    const { notifications } = data?.data || {};
    useStore.setState(
      produce((draft) => {
        draft.notification.isUnReadInitialized = true;
        draft.notification.unRead = notifications;
      }),
    );

    dispatchFetchTasks();
  }
};

// export const updateUnreadNotificationCount = (count) => {
//   useStore.setState(
//     produce((draft) => {
//       draft.notification.unRead = count;
//     }),
//   );
// };

export const dispatchReadNotification = async (notificationId, status) => {
  const path = `/notification/${notificationId}/${status}`;

  const { data, ok } = await authorizedServerFetch(path, {
    method: 'PUT',
    body: {},
  });

  useStore.setState(
    produce((draft) => {
      const cachedNotification = draft.notification.allRows.find(
        (obj) => obj.id === notificationId,
      );
      if (cachedNotification) {
        if (status === 'read') {
          cachedNotification.appNotification.readOn = new Date().toISOString();
          draft.notification.unRead -= 1;
        } else {
          cachedNotification.appNotification.readOn = null;
          draft.notification.unRead += 1;
        }
      }
    }),
  );
};

export const onTaskCompleted = (task) => {
  useStore.setState(
    produce((draft) => {
      draft.notification.tasks = draft.notification.tasks.filter(
        (obj) => obj.createdAt !== task.createdAt,
      );
      draft.notification.pendingTaskCount = draft.notification.tasks.length;
    }),
  );

  dispatchGetUnreadCount();
};
